import { render } from "./FinishedPeriodMenu.vue?vue&type=template&id=1856e72f&scoped=true&ts=true"
import script from "./FinishedPeriodMenu.vue?vue&type=script&lang=ts"
export * from "./FinishedPeriodMenu.vue?vue&type=script&lang=ts"

import "./FinishedPeriodMenu.vue?vue&type=style&index=0&id=1856e72f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1856e72f"]])

export default __exports__